<template>
  <div :style="wrapStyle">
    <h1 :class="getCss('answerQuestion')">{{ QuestionText }}</h1>
    <ul :class="getCss('answerList')">
      <li :class="{ 'choiceAnswer' : choiceAnswer === 'A'}" @click="choiceAnswer = 'A'">{{ AnswerAText }}</li>
      <li :class="{ 'choiceAnswer' : choiceAnswer === 'B'}" @click="choiceAnswer = 'B'">{{ AnswerBText }}</li>
      <li :class="{ 'choiceAnswer' : choiceAnswer === 'C'}" @click="choiceAnswer = 'C'">{{ AnswerCText }}</li>
    </ul>
    <button class="answerButton" :class="{'answerButtonDone' : AnswerDone}" @click="requestAnswer()"></button>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'CBbAnswer',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'bb-answer-',
      choiceAnswer: false,
      QuestionText: '',
      AnswerAText: '',
      AnswerBText: '',
      AnswerCText: '',
      AnswerDone: false,
      CorrectAnswer: 'noData',
    };
  },
  computed: {
    wrapStyle() {
      return {
        ...this.styles.base,
      };
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$onQuaRefreshed(async () => {
        try {
          const response = await this.flowRequest({
            flowId: this.configurationData.getQuestionFlowId,
            params: {
              role: this.roleInfo,
            },
          });
          console.log('getQuestionFlowId ret response=  ', response);
          if (!response.data.ret && !response.ret) {
            this.QuestionText = response.data.question;
            this.AnswerAText = response.data.answer_a;
            this.AnswerBText = response.data.answer_b;
            this.AnswerCText = response.data.answer_c;
            this.CorrectAnswer = response.data.list.answer;
          }
        } catch (e) {
          console.log('getQuestionFlowId fail,er=', e);
        }

        try {
          const response = await this.flowRequest({
            flowId: this.configurationData.todayAnswerDoneFlowId,
            params: {
              role: this.roleInfo,
            },
          });
          console.log('todayAnswerDoneFlowId ret response=  ', response);
          if (!response.data.ret && !response.ret) {
            this.AnswerDone = Number(response.data.useNum) >= 1;
          }
        } catch (e) {
          console.log('todayAnswerDoneFlowId fail,er=', e);
        }
      });
    },
    async requestAnswer() {
      if (this.AnswerDone) {
        return false;
      }
      console.log('Answer', this.choiceAnswer);
      if (this.choiceAnswer === false) {
        return alert('请选择答案后再提交!');
      }
      if (this.choiceAnswer !== this.CorrectAnswer) {
        return alert('哎呀 答错啦，再试一次吧~');
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.answerFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            answer: this.choiceAnswer
          }),
        },
      });

      console.log('CBbHonorReward rewardFlowId ret  response=  ', response);
      if (response.ret === 0 && response.data.ret === 0) {
        alert('恭喜您回答正确，获得今日答题奖励! 每日分享一次活动页面还可获得分享奖励哦~ 游戏上线后，登录活动页面并绑定角色 即可完成游戏道具发放');
        this.AnswerDone = true;
      } else {
        // 验证下是否是该字段为错误提示 response.data.msg response.msg
        const errorMsg = response.data.msg ? response.data.msg : response.msg;
        alert(errorMsg);
      }
      this.refreshQua(); // 刷新礼包
      console.log('answer done');
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
